
export default {
  props: ['query', 'suggestions', 'categories', 'projects', 'products', 'no_results'],
  methods: {
    highlight(value) {
      if (!value || this.$props.query === undefined) return ''
      const params = this.$props.query.replace(/\s+/g, '|'); //Oder anweisung
      const regex = new RegExp('(' + params + ')','ig')
      return value.replace(regex, '<span class="highlight">$1</span>');
    },

    //Klick events
    clickSubmitForm(param) {
      this.$emit('submitForm', param)
    },

    clickCategory(category) {
      window.location.href = category.url
    },

    clickProduct(product) {
      window.location.href = product.url
    },

    clickProject(project) {
      window.location.href = project.url
    }
  },
}
